import React, { Component } from 'react';
import AltinKur from './../components/altinkur';
import Bant from './../components/bant';
import http from "./../services/httpService";
import config from "./../config.json";

class IscilikSayfa extends Component {
    state = {  
        avalues: [],
        dvalues: [],
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        document.title = "Altınkaynak Şirketler Grubu - Canlı İşçilik Bilgileri"
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async setValues(){
        if(JSON.parse(localStorage.getItem('avalues')) !== null){
            this.setState({avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues'))})
        }

        var {data : avalues} =  await http.get(config.restEndpoint + 'Gold');
        localStorage.setItem('avalues', JSON.stringify(avalues));
        var {data : dvalues} =  await http.get(config.restEndpoint + 'Currency');
        localStorage.setItem('dvalues', JSON.stringify(dvalues));

        if(avalues !== null & dvalues !== null)
            this.setState({dvalues,avalues})
    }

    render() { 
        return <React.Fragment>
                <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-12">
                                <AltinKur main={false} group={5} showdescription={true} header={'Sarrafiye İşçilik'} values={this.state.avalues}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-12">
                                <AltinKur main={false} group={6} showdescription={true} header={'Gram Altın İşçilik'} values={this.state.avalues} />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>;
    }
}
 
export default IscilikSayfa;